import React, { Fragment } from 'react';

import Header from '../FixedSections/Header/Header';
import Footer from '../FixedSections/Footer/Footer';
import Sections from '../sections/Sections';

const Layout = () => {
  return (
    <Fragment>
      <Header />
      <main>
        <Sections />
      </main>
      <Footer />
    </Fragment>
  );
};

export default Layout;
